import React from "react";
import { useGlobalContext } from "./context/globalContext";

const Slider = ({ project, title, images }) => {
  const { handleShowModal } = useGlobalContext();

  return (
    <section className="section shadow-sm lazyloaded" id={`${title}`}>
      <span className="section-link"></span>
      <div className="row">
        <div className="col-md-8">
          <h2 className="head text-capitalize">
            {project} - {title}
          </h2>
        </div>
        <div className="col-md-4">
          <button
            className="btn btn-info micro-form-btn enqModal effetMoveGradient effectScale float-lg-right mx-sm-auto d-none d-lg-block"
            onClick={() => handleShowModal(`Download ${title}`)}
          >
            Download {title}
          </button>
        </div>
      </div>

      <div className="owl-carousel-img owl-carousel owl-theme gallery-img">
        {images.map((amenity, index) => (
          // at-property-item
          <div
            key={index}
            data-fancybox="gallery-0"
            className="at-property-item"
            onClick={() => handleShowModal(`Download ${title}`)}
          >
            {/* at-property-img */}
            <div className="">
              <img
                loading="lazy"
                className="gallery-thumb ls-is-cached lazyloaded at-property-img"
                src={amenity.src}
                alt={amenity.alt}
              />
              <span
                className="btn btn-default at-property-btn"
                role="button"
                onClick={() => handleShowModal(`Download ${title}`)}
              >
                View Amenities
              </span>
            </div>
          </div>
        ))}
      </div>

      <div className="col-12">
        <button
          className="chat-btn btn btn-info micro-form-btn enqModal effetMoveGradient effectScale float-lg-right mx-sm-auto d-lg-none"
          data-form="lg"
          data-title="Download Gallery"
          data-btn="Send Now"
          data-enquiry="Download Gallery"
          data-redirect="floorplan"
          data-toggle="modal"
          data-target="#enqModal"
          onClick={() => handleShowModal(`Download ${title}`)}
        >
          Download {title}
        </button>
      </div>
    </section>
  );
};

export default Slider;
